import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Button } from 'semantic-ui-react'
import TitDer from '../../../components/funcionales/titder';
import { List } from 'semantic-ui-react'

import SeguroPermite from '../../../components/funcionales/seguropermite'

import XLSX from 'xlsx'
import { saveAs } from 'file-saver';

//utils
import queries from '../../../utils/queries'
var moment = require('moment');

const DetallePl = ({elemento, indice, handleChange}) => {
  let urlSlcm = 'https://montserratslcm.com/api/cotizaciones/'

  let numDiasComp= 0, numDiasReal= 0, numDiasEjec = 0
  let estadoGestion='', motivoGestion=''
  let colorCeldaReal='white'
  if(elemento.estadoCoti!=='Cancelada'){
    // numDiasComp = moment(elemento.fechaFin, 'YYYY-MM-DD').diff(moment(elemento.fechaOrdenCliente, 'YYYY-MM-DD'), 'days') 
    numDiasComp = 3 
    if(elemento.estadoCoti==='Aprobada'){
      // if(elemento.fechaEjec){
      //   numDiasReal = moment(elemento.fechaEjec, 'YYYY-MM-DD').diff(moment(elemento.fechaAut, 'YYYY-MM-DD'), 'days') 
      //   if(parseInt(numDiasReal)>parseInt(numDiasComp)){
      //     colorCeldaReal = 'red'
      //   }else{
      //     colorCeldaReal = 'green'
      //   }
      // }else{
        numDiasReal = moment(new Date(), 'YYYY-MM-DD').diff(moment(elemento.fechaAut, 'YYYY-MM-DD'), 'days') 
        if(parseInt(numDiasReal)>parseInt(numDiasComp)){
          colorCeldaReal = 'red'
        }else{
          if(numDiasComp-numDiasReal>=3){
            colorCeldaReal = 'yellow'
          }else{
            colorCeldaReal = 'green'
          }
        }
      // }  
      if(elemento.cantidadDespacho && elemento.cantidadDespacho>0 && elemento.cantidadDespacho === elemento.cantidadCoti){
        estadoGestion='Monitoreo'
        motivoGestion='Pendiente de acta de entrega'
      }else{
        if(elemento.cantidadCompra && elemento.cantidadCompra>0){
          if(elemento.cantidadCompraEjec && elemento.cantidadCompraEjec>0){
            if(elemento.cantidadCompra <= elemento.cantidadCompraEjec){
              estadoGestion='Monitoreo'
              motivoGestion='Comprado - pendiente de despacho'
            }else{
              estadoGestion='Monitoreo'
              motivoGestion='Compra parcial - pendiente de compras'
            }
          }else{
            estadoGestion='Monitoreo'
            motivoGestion='Pendiente de compras'
          }
        }else{
          estadoGestion='En ejecución'
          motivoGestion='Sin gestión'
        }
      }    
    }else{
      numDiasReal = moment(elemento.fechaEjec, 'YYYY-MM-DD').diff(moment(elemento.fechaAut, 'YYYY-MM-DD'), 'days') 
      if(parseInt(numDiasReal)>parseInt(numDiasComp)){
        colorCeldaReal = 'red'
      }else{
        colorCeldaReal = 'green'
      }
      estadoGestion='Ejecutado'
      motivoGestion='Solicitud cerrada'
    }
  }else{
    estadoGestion='Cancelado'
  }

  return(
    <tr className=''>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEmpresa}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.numCoti}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.estadoCoti}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaAut?elemento.fechaAut.substr(0, 10):''}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrProducto}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cantidadCoti}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrUnidad}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{estadoGestion}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{motivoGestion}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{numDiasComp}</td>
      <td className='' style={{color: 'black', background: colorCeldaReal, paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{numDiasReal}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaEjec?elemento.fechaEjec.substr(0, 10):''}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cantidadDespacho?elemento.cantidadDespacho:0}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cantidadCompra?elemento.cantidadCompra:0}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cantidadCompraEjec?elemento.cantidadCompraEjec:0}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaEjecCompra?elemento.fechaEjecCompra.substr(0, 10):''}</td>
      <td className='' style={{color: 'black', background: '#FFFFFF'}}>
        <a style={{color: 'black'}}
          // href={'images/cotizaciones/' + elemento.informe}
          href={urlSlcm + elemento.informe}
            target="_blank">
          {elemento.informe}
        </a>
      </td>
      {/* <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.usuarioAutOC}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaFinReal?elemento.fechaFinReal.substr(0, 10):''}</td>
      <td className='' style={{color: 'black', background: colorCeldaReal, paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{numDiasReal}</td> */}
    </tr>
  )
};
const ListaPl = ({list, handleChange}) => {
    const nivel1Detalle = list.map((elemento, i) => <DetallePl elemento={elemento} key={i} indice={i}
      handleChange={handleChange}/>);
    return(
      <tbody className=''>
        {nivel1Detalle}
      </tbody>
    )
  };

class GerSegTras2 extends React.Component {
  state={list: this.props.allCotizacionRtesTras.allCotizacionRtes?this.props.allCotizacionRtesTras.allCotizacionRtes:[],
    argsDocum: {desde: this.props.fechaHoy, hasta: this.props.fechaFin},
    permiteUpdate: true, confirmaAct: false, open: false, argsBuscCoti: {}, ingresa: 'S',
    argsQuery: `{$project: { 
      itemsCoti: {
                    $let: {
              vars: {regItem: { $cond: { if: { $isArray: "$itemsCoti" },
                                          then: { $size: "$itemsCoti" },
                                          else: 0} }
            },
            in: { $cond: { if: { $gt: [ "$$regItem", 0 ] },
                                then: "$itemsCoti",
                                else: [{cantidadCoti: 0, cantidadDespacho: 0, cantidadCompra: 0, cantidadCompraEjec: 0, 
                                  fechaEjecCompra: '', descrProducto: '', descrUnidad: ''}] 
            }}
        }},
        tipoCoti: 1, numCoti: 1, estadoCoti: 1, descrEmpresa: 1, fechaAut: 1, fechaEjec: 1, informe: 1
      }},
    {"$unwind": "$itemsCoti"},
    {$project: {tipoCoti: 1, numCoti: 1, estadoCoti: 1, descrEmpresa: 1, fechaAut: 1, fechaEjec: 1, informe: 1,
      cantidadCoti: '$itemsCoti.cantidadCoti', cantidadDespacho: '$itemsCoti.cantidadDespacho', 
      cantidadCompra: '$itemsCoti.cantidadCompra', 
      cantidadCompraEjec: '$itemsCoti.cantidadCompraEjec', fechaEjecCompra: '$itemsCoti.fechaEjecCompra', 
      descrProducto: '$itemsCoti.descrProducto', descrUnidad: '$itemsCoti.descrUnidad'}},
    {$project: {_id: {$concat: ['$numCoti', '$descrProducto']}, tipoCoti: 1, numCoti: 1, estadoCoti: 1, 
      descrEmpresa: 1, fechaAut: 1, fechaEjec: 1, informe: 1, cantidadCoti: 1, 
      cantidadDespacho: 1, cantidadCompra: 1, cantidadCompraEjec: 1, fechaEjecCompra: 1, 
      descrProducto: 1, descrUnidad: 1}}
    `
  }


  handleChange = async (ev, indice) => {

    if(ev.target.name==="desde"||ev.target.name==="hasta"){
      const argsDocum = this.state.argsDocum
      argsDocum[ev.target.name] = ev.target.value
      let argsBuscar=`'tipoCoti': 'Traslado', 'estadoCoti': {$ne: 'Creada'}`
      if(ev.target.name==="desde"){
        argsBuscar += `, fechaAut: { $gte: new Date('${ev.target.value}')}`
      }else{
        argsBuscar += `, fechaAut: { $gte: new Date('${argsDocum.desde}')}`
      }
      if(this.props.argsBuscCoti.numCoti){
        argsBuscar += `, 'numCoti': ${this.props.argsBuscCoti.numCoti}`
      }
      if(this.props.argsBuscCoti.descrEmpresa){
        argsBuscar += `, 'descrEmpresa': /${this.props.argsBuscCoti.descrEmpresa}/i`
      }
      if(this.props.argsBuscCoti.estadoCoti){
        argsBuscar += `, 'estadoCoti': /${this.props.argsBuscCoti.estadoCoti}/i`
      }
      let argsBuscar2=""
      if(ev.target.name==="desde"){
        argsBuscar2 = `fechaAut: { $lte: new Date('${argsDocum.hasta}') }`
      }else{
        argsBuscar2 = `fechaAut: { $lte: new Date('${ev.target.value}') }`
      }
      if(this.props.argsBuscCoti.descrProducto){
        argsBuscar2 += `, 'descrProducto': /${this.props.argsBuscCoti.descrProducto}/i`
      }      
      
      let argsBuscarPl = {tipoqry: `[{$match: {${argsBuscar}}}, ${this.state.argsQuery}, 
        {$match: {${argsBuscar2}}}, 
        {$sort: {fechaAut: 1}}]`}

      console.log(argsBuscarPl)
      await this.props.allCotizacionRtesTras.refetch(argsBuscarPl)
      if(this.props.allCotizacionRtesTras.allCotizacionRtes){
        this.setState({list: 
          this.props.allCotizacionRtesTras.allCotizacionRtes?this.props.allCotizacionRtesTras.allCotizacionRtes:[]
        })
      }
      this.setState({argsDocum});
    }
  }

  handleGenExc = async (ev, list)=>{
    if(list.length>0){
      document.body.style.cursor = 'wait'
      //Archivo Excel
      let xlsString = []
      let xlsString1 = []
      xlsString1 = ['CLIENTE', 'SOLICITUD', 'ESTADO', 'FECHA ASIGNACION', 'DESCRIPCION', 'PEDIDO', 'UNIDAD', 'ESTADO GESTION', 'MOTIVO GESTION', 'DIAS COMPROMISO',
        'DIAS TRANSCURRIDOS', 'AVISO', 'FECHA ENVIO', 'DESPACHADO', 'SOLICITUD DE COMPRA', 'COMPRADO', 'FECHA DE COMPRA']
      xlsString.push(xlsString1)

      for (let iiii=0;iiii<list.length;iiii++){
        let numDiasComp= 0, numDiasReal= 0, numDiasEjec = 0
        let estadoGestion='', motivoGestion=''
        let aviso=''
        if(list[iiii].estadoCoti!=='Cancelada'){
          // numDiasComp = moment(list[iiii].fechaFin, 'YYYY-MM-DD').diff(moment(list[iiii].fechaOrdenCliente, 'YYYY-MM-DD'), 'days') 
          numDiasComp = 3 
          if(list[iiii].estadoCoti==='Aprobada'){
            // if(list[iiii].fechaEjec){
            //   numDiasReal = moment(list[iiii].fechaEjec, 'YYYY-MM-DD').diff(moment(list[iiii].fechaOrdenCliente, 'YYYY-MM-DD'), 'days') 
            //   if(parseInt(numDiasReal)>parseInt(numDiasComp)){
            //     aviso = 'PELIGRO'
            //   }else{
            //     aviso = 'VIGENTE'
            //   }
            // }else{
              numDiasReal = moment(new Date(), 'YYYY-MM-DD').diff(moment(list[iiii].fechaAut, 'YYYY-MM-DD'), 'days') 
              if(parseInt(numDiasReal)>parseInt(numDiasComp)){
                aviso = 'PELIGRO'
              }else{
                if(numDiasComp-numDiasReal>=2){
                  aviso = 'ALARMA'
                }else{
                  aviso = 'VIGENTE'
                }
              }
            // }  
            if(list[iiii].cantidadDespacho && list[iiii].cantidadDespacho>0 && list[iiii].cantidadDespacho === list[iiii].cantidadCoti){
              estadoGestion='Monitoreo'
              motivoGestion='Pendiente de acta de entrega'
            }else{
              if(list[iiii].cantidadCompra && list[iiii].cantidadCompra>0){
                if(list[iiii].cantidadCompraEjec && list[iiii].cantidadCompraEjec>0){
                  if(list[iiii].cantidadCompra <= list[iiii].cantidadCompraEjec){
                    estadoGestion='Monitoreo'
                    motivoGestion='Comprado - pendiente de despacho'
                  }else{
                    estadoGestion='Monitoreo'
                    motivoGestion='Compra parcial - pendiente de compras'
                  }
                }else{
                  estadoGestion='Monitoreo'
                  motivoGestion='Pendiente de compras'
                }
              }else{
                estadoGestion='En ejecución'
                motivoGestion='Sin gestión'
              }
            }    
          }else{
            numDiasReal = moment(list[iiii].fechaEjec, 'YYYY-MM-DD').diff(moment(list[iiii].fechaAut, 'YYYY-MM-DD'), 'days') 
            if(parseInt(numDiasReal)>parseInt(numDiasComp)){
              aviso = 'PELIGRO'
            }else{
              aviso = 'VIGENTE'
            }
            estadoGestion='Ejecutado'
            motivoGestion='Solicitud cerrada'
          }
        }else{
          estadoGestion='Cancelado'
        }

        xlsString1 = [list[iiii].descrEmpresa, list[iiii].numCoti, list[iiii].estadoCoti, list[iiii].fechaAut.substr(0, 10), 
            list[iiii].descrProducto, list[iiii].cantidadCoti, 
            list[iiii].descrUnidad, estadoGestion, motivoGestion, numDiasComp, numDiasReal, aviso, 
            list[iiii].fechaEjec?list[iiii].fechaEjec.substr(0, 10):'', list[iiii].cantidadDespacho?list[iiii].cantidadDespacho:0, 
            list[iiii].cantidadCompra?list[iiii].cantidadCompra:0, 
            list[iiii].cantidadCompraEjec?list[iiii].cantidadCompraEjec:0, list[iiii].fechaEjecCompra?list[iiii].fechaEjecCompra.substr(0, 10):'']
        xlsString.push(xlsString1)

        if(iiii===list.length-1){
          var wb = XLSX.utils.book_new();

          wb.Props = {
            Title: "SheetJS Tutorial",
            Subject: "Test",
            Author: "Red Stapler",
            CreatedDate: new Date(2017,12,19)
          };

          wb.SheetNames.push("Seguimiento");

          let ws_data = xlsString;

          let ws = XLSX.utils.aoa_to_sheet(ws_data);
          wb.Sheets["Seguimiento"] = ws;
          let wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
          function s2ab(s) { 
            let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
            let view = new Uint8Array(buf);  //create uint8array as viewer
            for (let i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
            return buf;    
          }
          saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), 'Seguimiento_TRASLADOS.xlsx');
//FIN Exportar a XLS
        }

        document.body.style.cursor = 'default'

        this.setState({open: false, confirmaAct: false})
      }
    }
  }
  

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){
      this.setState({open: true})
    }else{
      this.setState({open: false})
    };
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  async componentDidUpdate(prevProps){
    if(this.props.argsBuscCoti!==prevProps.argsBuscCoti || this.state.ingresa==='S'){
      let argsBuscar=`'tipoCoti': 'Traslado', 'estadoCoti': {$ne: 'Creada'}, 'fechaAut': { $gte: new Date('${this.state.argsDocum.desde}')}`
      if(this.props.argsBuscCoti.numCoti){
        argsBuscar += `, 'numCoti': ${this.props.argsBuscCoti.numCoti}`
      }
      if(this.props.argsBuscCoti.descrEmpresa){
        argsBuscar += `, 'descrEmpresa': /${this.props.argsBuscCoti.descrEmpresa}/i`
      }
      if(this.props.argsBuscCoti.estadoCoti){
        argsBuscar += `, 'estadoCoti': /${this.props.argsBuscCoti.estadoCoti}/i`
      }
      let argsBuscar2=`fechaAut: { $lte: new Date('${this.state.argsDocum.hasta}') }`
      if(this.props.argsBuscCoti.descrProducto){
        argsBuscar2 += `, 'descrProducto': /${this.props.argsBuscCoti.descrProducto}/i`
      }
      
      let argsBuscarPl = {tipoqry: `[{$match: {${argsBuscar}}}, ${this.state.argsQuery}, 
        {$match: {${argsBuscar2}}}, 
        {$sort: {numOrdenCompra: 1}}]`}

      console.log(argsBuscarPl)
      await this.props.allCotizacionRtesTras.refetch(argsBuscarPl)
      if(this.props.allCotizacionRtesTras.allCotizacionRtes){
        this.setState({list: 
          this.props.allCotizacionRtesTras.allCotizacionRtes?this.props.allCotizacionRtesTras.allCotizacionRtes:[]
        })
      }
      this.setState({ingresa: 'N'}) 
    }
  }

  render(){
    const {list, argsDocum, checkSeleccInfAll, permiteUpdate, confirmaAct, open} = this.state;

    // const a250110 = autorizacUA.findIndex( autorizac => autorizac === "250110" );
    let mensaje = "Generar Excel de informe"
    let imgIcon = "images/documento_32.png"
    

    // trmcol.query('2023-05-15')
    //   .then(trm => console.log(trm))
    //   .catch(err => console.log(err))
    

console.log(list)

//     let list1 = []
//     if(list.length>0){
//       list1=list
//     }else{
//       if(this.props.allCotizacionRtes.allCotizacionRtes){
//         this.props.allCotizacionRtes.refetch()
//         list1 = this.props.allCotizacionRtes.allCotizacionRtes
//       }
//     }
// console.log(list1)

return (
  <div>
    <List selection>
      <TitDer list={list} textBoton1="Seguimiento logístico" btnNuevo={"NO"} styles={this.props.styles} handleClick={this.props.handleClick} />
        <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, list, argsDocum):()=>{}}>
            <div className="ui three column stackable grid">
              {/* <div className="row container"> */}
                <div className="column" style={{width: '15%'}}>
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.0em 0em 0em 0em'}}>
                    Fecha asignación desde
                  </p>
                  <Form.Field>
                    <input style={this.props.styles.input} type='date' name="desde" id="desde" value={argsDocum.desde} onChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: '15%'}}>
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.0em 0em 0em 0em'}}>
                  Fecha asignación hasta
                  </p>
                  <Form.Field>
                    <input style={this.props.styles.input} type='date' name="hasta" id="hasta" value={argsDocum.hasta} onChange={this.handleChange}/>
                  </Form.Field>
                </div>
                {/* {localStorage.getItem('userLogin')==="slcm@slcm.com" && */}
                  <div className="column" style={{width: '18%', paddingTop: '0.0em'}}>
                    <br></br>
                    <br></br>
                    <Button id="excel" name="excel" style={this.props.styles.confirmar} onClick={(ev)=>this.handleGenExc(ev, list)} fluid>
                      Exportar a excel
                    </Button>
                  </div>
                {/* }  */}
              {/* </div> */}
            </div>
            {/* <br></br> */}
            <div>
              <div style={{height: '45em', overflow: 'auto'}}>
                <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cliente</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Solicitud</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Estado</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Fecha asignación</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Producto</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cantidad</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Unidad</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Estado gestión</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Motivo gestión</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Días compromiso</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Días transcurridos</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Fecha envío</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Despachado</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Solic. compra</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Comprado</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Fecha compra</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Archivo informe</th>
                     </tr>
                  </thead>
                  <ListaPl list={list} handleChange={this.handleChange}/>
                </table>
                <p></p>
              </div>
            </div>
          </Form>
        </div>
      </List>
    </div>
    )
  }
};

export default compose(
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtesTras',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
)(GerSegTras2)
